import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import Logo from '../../../../Resources/Logo/LogoBordered.png';

export default function EmergencyPaymentStatus(){

    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const status = routeParams.status;
    const successMsg = 'Payment made successfully!'
    const errorMsg = 'An error has occurred when processing this payment.'


    return(
        <div className="login-container">
            <div className="coloured-box-container">
                <div className='coloured-box'></div>
            </div>


            <div className='login-form-container'>

                <div className='login-form-card'>
                
                <>
                    <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                        <img src={Logo} alt="LogoBordered" className="LogoBordered" />
                    </div>
                    <div className="m-2">
                        <div className='mt-2'>
                            <STC.Alert variant={status === 'success' ? 'success' : 'danger'}>
                                {status === 'success' ? successMsg : errorMsg}
                            </STC.Alert>
                        </div>
                    </div>
                    <div className="mt-2 text-center">
                            <span
                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                onClick={()=> navigate('/')}
                            >
                                Return to Login
                            </span>
                        </div>
                    </>
                </div>
                
            </div>
        </div>
    )
}